module.exports = __webpack_public_path__ + "static/media/ic_close.3e15e8b9.svg";